import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      localRegion: {
        name: '',
        short_name: '',
        cities: []
      },
      regionTable: 'regions',
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên vùng miền', trigger: 'change'},
          {min: 5, max: 255, message: 'Tên vùng miền phải trong khoảng 5 đến 255 ký tự', trigger: 'change'}
        ],
        short_name: [
          {required: true, message: 'Bạn chưa nhập tên viết tắt', trigger: 'change'},
          {min: 1, max: 255, message: 'Tên vùng viết tắt phải trong khoảng 1 đến 255 ký tự', trigger: 'change'}
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapGetters('city', ['cities'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    newRegion () {
      this.localRegion = {
        name: '',
        short_name: '',
        cities: []
      }
    }
  },
  mounted () {
    this.newRegion()
    if (!this.cities.length) {
      this.getAllCity({limit: -1, sort: 'name:1'})
    }
  },
  watch: {
    localRegion: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/region/mixins/index.js